import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';

@Component({
  selector: 'app-activate-account',
  standalone: false,
  templateUrl: './activate-account.component.html',
  styleUrl: './activate-account.component.scss',
})
export class ActivateAccountComponent implements OnInit {
  activationForm: FormGroup;

  loading = true;
  submitting = false;
  success = false;
  error = false;
  errorMessage = '';

  manualMode = false;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
  ) {
    this.activationForm = this.fb.group({
      action: ['validNewUser'],
      email: ['', [Validators.required, Validators.email]],
      oneTimeCode: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const action = params['action'] || 'validNewUser';
      const email = params['email'];
      const oneTimeCode = params['oneTimeCode'] || params['otc'];

      if (action === 'validNewUser' && email && oneTimeCode) {
        this.manualMode = false;

        this.activationForm.patchValue({
          action,
          email,
          oneTimeCode,
        });

        this.loading = false;
        return;
      }

      this.manualMode = true;

      this.activationForm.patchValue({
        action: 'validNewUser',
      });

      this.loading = false;
    });
  }

  onSubmit(): void {
    if (this.activationForm.invalid) {
      this.activationForm.markAllAsTouched();
      return;
    }

    this.submitting = true;
    this.error = false;
    this.errorMessage = '';

    const { action, email, oneTimeCode } = this.activationForm.value;

    this.authService.activateNewUser(action, email, oneTimeCode).subscribe({
      next: () => {
        this.submitting = false;
        this.success = true;
      },
      error: (err: any) => {
        this.submitting = false;
        this.error = true;
        this.errorMessage =
          err.error?.message || err.message || 'Activation failed';
      },
    });
  }

  navigateToLogin(): void {
    this.router.navigate(['/login']);
  }
}
